import React, { useState } from 'react';
import { useAuth } from './AuthContext.jsx';
import { BackgroundWaves } from '../components';
import { useTheme } from '../hooks';

export default function Login() {
  const { login } = useAuth();
  const { isDarkTheme, toggleTheme, themeClass } = useTheme();
  const [email, setEmail] = useState('admin');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch {
      setError('Usuario o contrasena invalidos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`app-container ${themeClass}`}>
      <BackgroundWaves />

      {/* Theme Toggle en la esquina */}
      <div style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 100 }}>
        <button className="theme-toggle" onClick={toggleTheme}>
          <span className="theme-toggle-icon">{isDarkTheme ? '☀️' : '🌙'}</span>
          <span>{isDarkTheme ? 'Claro' : 'Oscuro'}</span>
        </button>
      </div>

      {/* Login Container */}
      <div className="login-container">
        <div className="login-card fade-in">
          {/* Logo */}
          <div className="login-logo">
            <div className="login-logo-icon">🌊</div>
            <span className="login-logo-text">Aqua Monitor</span>
          </div>

          <p className="login-subtitle">Inicia sesion para acceder al sistema de monitoreo</p>

          {/* Login Form */}
          <form className="login-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Usuario</label>
              <input
                className="input"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin"
                autoComplete="username"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Contrasena</label>
              <input
                className="input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contrasena"
                autoComplete="current-password"
              />
            </div>

            {error && <div className="login-error">{error}</div>}

            <button className="btn login-btn" type="submit" disabled={loading}>
              {loading ? 'Iniciando sesion...' : 'Iniciar Sesion'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
